import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
  configApiRef,
  identityApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { awsCredentialsApiRef } from '@eng-portal/czi-extensions-react';
import { rootRouteRef } from './routes';
import { AWSKeyManagementClient, awsKeyManagementApiRef } from './apis/keyManagementApi';
import { MockAWSKeyManagementClient } from './mocks/mockKeyManagementApi';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { PermissionConfig } from '@eng-portal/czi-extensions-common';

const keyManagementApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: awsKeyManagementApiRef,
      deps: { awsCredentialsApi: awsCredentialsApiRef, identityApi: identityApiRef, configApi: configApiRef },
      factory: ({ awsCredentialsApi, identityApi, configApi }) => {
        if (configApi.getOptionalBoolean('app.e2eTestMode')) {
          return new MockAWSKeyManagementClient();
        }
        return new AWSKeyManagementClient(awsCredentialsApi, identityApi, configApi);
      },
    }),
});

const keyManagementPage = PageBlueprint.make({
  params: {
    path: '/aws-key-management',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/KeyManagementRootPage').then(m => (
        <RequirePermission permission={PermissionConfig.keyManagementRootView.permission}>
          <m.KeyManagementRootPage />
        </RequirePermission>
      )),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'aws-key-management',
  extensions: [keyManagementApi, keyManagementPage],
  routes: {
    root: rootRouteRef,
  },
});
export default plugin;
